import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { IHTMLDiv } from "../interfaces/InputsInterfacesType1";
import { IInputValidationItemController } from "../../../../factorys/inputvalidation/interfaces/InputValidationInterfaces";

/**
 * works for;
 * TextInput, SelectInput
 */
interface IProps<T> {
  value: T | undefined;
  disabled?: boolean | undefined;
  classNameInput?: string;
  classNameFrame?: string;
  disabledClass: string;
  onMount?: (() => void);
}
interface IReturnProps<T>  extends IInputValidationItemController {
  blur: boolean; setBlur: Dispatch<SetStateAction<boolean>>;
  focused: boolean; setFocused: Dispatch<SetStateAction<boolean>>;
  setRefFrame: (it: IHTMLDiv | null) => void,
  refInput: HTMLUListElement | null, setRefInput: (it: HTMLUListElement | null) => void,
  value: T | undefined, setValue: Dispatch<T>
}
export const SelectCustomControllerType1 = <T>(props: IProps<T>): IReturnProps<T> => {
  
  const tag = " SelectCustomControllerType1";
  //console.log(tag + " START");

  const [blur, setBlur] = useState<boolean>(false);
  const [focused, setFocused] = useState<boolean>(false);

  const [value, setValue] = useState<T | undefined>(props.value);
  useEffect(() => {
    //console.log("value: " +value)
  }, [value]);
 

  //refs
  let refFrame: IHTMLDiv | null = null;
  function setRefFrame(it: IHTMLDiv | null) {
    try {
      if (it == null) return;
      refFrame = it;
      setDisabled(props.disabled);
    } catch (e) {}
  }

  let refInput: HTMLUListElement | null = null;
  function setRefInput(it: HTMLUListElement | null) {
    try {
      if (it == null) return;
      refInput = it;
      setDisabled(props.disabled);
    } catch (e) {}
  }
  //states


  //init
  useEffect(() => {
    //console.log(tag + " => onMount");
    setDisabled(props.disabled);

    props.onMount? props.onMount():null
    //setDisabled(true)
    return () => {
      //console.log(tag + " => onUnmount");
    };
  }, []);


  useEffect(() => {
    try {
      setDisabled(props.disabled);
    } catch (e) {}
  }, [props.disabled]);



  function setDisabled(disabled: boolean = true) {
    if(refFrame != null) {
      try {
        refFrame.className = disabled ? (props.classNameFrame + " " + props.disabledClass) : props.classNameFrame!!;
      } catch (e) {
        refFrame!!.className = disabled ? (props.disabledClass) : "";
      }
    }

    if(refInput != null) {
      try {
          //refInput.disabled = disabled;
          //refInput.className = disabled ? (props.classNameInput!! + " " + props.disabledClass) : props.classNameInput!!;
        } catch (e) {
          //refFrame!!.className = disabled ? (props.disabledClass) : "";
        } 
    }
  }

  return { 
    //states
    blur, setBlur,
    focused, setFocused,
    value, setValue,
    //refs
    setRefFrame, 
    refInput, setRefInput
  };
}